import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/app/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/components/NavClient.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/components/PageViewTracker.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
